import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { apiUrl, nodeEnv } from '../variables';
import { IEchoInstance } from '../interfaces/chat/websocket.interface';

declare global {
  interface Window {
    Pusher: typeof Pusher;
    Echo: IEchoInstance | null;
  }
}

const WS_HOST = process.env.REACT_APP_CHAT_WS_HOST || '127.0.0.1';
const WS_PORT = Number(process.env.REACT_APP_CHAT_WS_PORT) || 8080;
const WS_KEY = process.env.REACT_APP_CHAT_WS_KEY || '5mlmmq8mxftbhp4bncji';
const WS_CLUSTER = process.env.REACT_APP_CHAT_WS_CLUSTER || 'mt1';

const isProduction = nodeEnv !== 'local';

let echoInstance: IEchoInstance | null = null;

export const initializeWebSocket = async (): Promise<IEchoInstance | null> => {
  if (echoInstance) return echoInstance;

  try {
    const token = localStorage.getItem('userStudent');
    if (!token || token === 'null') {
      return null;
    }

    window.Pusher = Pusher;

    const echo = new Echo({
      broadcaster: 'pusher',
      key: WS_KEY,
      cluster: WS_CLUSTER,
      wsHost: WS_HOST,
      wsPort: WS_PORT,
      wssPort: WS_PORT,
      forceTLS: isProduction,
      encrypted: isProduction,
      disableStats: true,
      enabledTransports: ['ws', 'wss'] as ('ws' | 'wss')[],
      authEndpoint: `${apiUrl}/chat/broadcasting/auth`,
      auth: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    });

    echoInstance = echo as unknown as IEchoInstance;
    window.Echo = echoInstance;

    return echoInstance;
  } catch (error) {
    return null;
  }
};

export const getEcho = async (): Promise<IEchoInstance | null> => {
  return echoInstance || (await initializeWebSocket());
};

export const disconnectWebSocket = (): void => {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
    window.Echo = null;
  }
};

